export const compareStrings = (a, b) => a < b ? -1 : (a > b ? 1 : 0)

export const formatInt = num => parseInt(num).toLocaleString('en-GB', { maximumFractionDigits: 0 })
export const formatPerc = num => (parseFloat(num) * 100).toLocaleString('en-GB', { maximumFractionDigits: 1, minimumFractionDigits: 1 }) + '%'

export const formatPhone = phone => {
  const phonere = /(27|0)(\d{2})(\d{3})(\d{4})/
  const match = phone.match(phonere)
  if (match) {
    return `0${match[2]} ${match[3]} ${match[4]}`
  } else {
    return phone
  }
}

export const intlPhone = phone => phone.replace(/^0/, '27')
